import { useState, useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import {
  Box,
  Typography,
  Hidden,
  IconButton,
  Drawer,
  CircularProgress,
  Popover,
  Button,
  Divider,
  Tooltip,
  AppBar,
  Toolbar
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import SettingsIcon from '@mui/icons-material/Settings'
import logo from '../../assets/Logo_TTGDA_Blanco.png'
import PingIndicator from '../PingIndicator'
import Awards from './NabvarAwards.js'
import LotOffers from '../LotOffers'
import UpdateUserGuarantee from '../UpdateUserGuarantee'
import GuaranteeChip from './GuaranteeChip'
import ConfirmationDialog from '../ConfirmationDialog'
import AutomaticAuctionDialog from '../AutomaticAuctionDialog'
import LotsOrderDialog from './LotsOrderDialog'
import AnnouncementNavBar from '../../pages/auction/components/AnnouncementNavBar'
import formatMoney from '../../utils/formatMoney'
import localStorageService from '../../services/localStorage'
// reportApi: solo lo usaba el bloque de RobinHood v1, comentado más abajo.
// import reportApi from '../../services/reports'
import { AUCTION_STATUS } from '../../utils/constants'
import {
  socketUser,
  socketAdmin,
  getAuctionSocket,
} from '../../services/socketAuction'
import useNavbarStyles from './NavbarStyles.js'
import SettingsPanel from './SettingsPanel.js'
// downloadReport: solo lo usaba el bloque de RobinHood v1, comentado más abajo.
// import { downloadReport } from './NavbarActions.js'
import {
  getColorClass,
  getSpecialMarkLabel,
  toggleDrawer,
  handleSettingsClick,
  handleUserClick,
  handleClose,
  logout,
  restartTutorial,
  syncUserGuarantee,
  restartAuction,
  updateAuction,
  getAuctionType
} from './NavbarUtils.js'
import { UserContext } from '../../context/userContext'
import { AuctionContext } from '../../context/auctionContext'
import { TutorialContext } from '../../context/tutorialContext'


const Navbar = () => {
  const classes = useNavbarStyles()
  const history = useHistory()
  const { userData, setUserData } = useContext(UserContext)
  const { auction } = useContext(AuctionContext)
  const { setShowTutorial } = useContext(TutorialContext)
  // Si el usuario es especial y tiene marca, se muestra la marca en vez del monto de garantía.
  const specialMarkLabel = getSpecialMarkLabel(userData)
  const [openDrawer, setOpenDrawer] = useState(false)
  const [userEl, setUserEl] = useState(null)
  const [settingsEl, setSettingsEl] = useState(null)
  const [ping, setPing] = useState()
  const [pingInterval, setPingInterval] = useState()
  const [loadingUpdate, setLoadingUpdate] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [openDialogUpdateAuction, setOpenDialogUpdateAcution] = useState(false)
  const [openAutomaticAuctionDialog, setOpenAutomaticAuctionDialog] = useState(false)
  const [openLotsOrderDialog, setOpenLotsOrderDialog] = useState(false)
  const [auctionType, setAuctionType] = useState("REMATES ONLINE")
  const URL = {
    client: /\/auction\/\d+$/.test(history.location.pathname),
    menu: /\/auction\/\d+\/admin\/menu$/.test(history.location.pathname),
    room: /\/auction\/\d+\/admin\/room$/.test(history.location.pathname),
    dashboard: /\/auction\/\d+\/admin\/dashboard(V2)?$/.test(
      history.location.pathname
    ),
    userControl: /\/auction\/\d+\/admin\/userControl$/.test(
      history.location.pathname
    ),
    // Código legado del RobinHood anterior a este rediseño, fuera de operación.
    // robinhood: /\/auction\/\d+\/admin\/RobinHood$/.test(
    //   history.location.pathname
    // ),
    auctioneer: /\/auction\/\d+\/admin\/auctioneer$/.test(
      history.location.pathname
    ),
    control: /\/auction\/\d+\/admin\/room$/.test(history.location.pathname),
    auctionList: history.location.pathname === '/auctionList',
  }
  useEffect(() => {
    const socket = getAuctionSocket()
    if (!pingInterval) {
      setPingInterval(
        setInterval(() => {
          const start = Date.now()
          socket.volatile.emit('ping', () => {
            const latency = Date.now() - start
            setPing(latency)
          })
        }, 1000)
      )
    }
    return () => {
      clearInterval(pingInterval)
    }
  }, [pingInterval])

  useEffect(() => {
    getAuctionType(auction, setAuctionType)
  }, [auction])

  useEffect(() => {
    socketUser.on('syncUserGuaranteeReady', () => {
      setUserData((user) => ({ ...user, loadingUserGuarantee: false }))
    })
    socketAdmin.on(`updateAuctionReady`, () => {
      setLoadingUpdate(false)
    })
    return () => {
      socketAdmin.off(`UserMakesOffer-${auction.id}`)
      socketUser.off(`syncUserGuaranteeReady`)
      socketAdmin.off(`updateAuctionReady`)
    }
  }, [auction.id, setUserData])

  return (
    <AppBar position="static" id="guaranteeBox">
      <Toolbar className={classes.rootNavbar}>
        <Box>
          {/* <a href="/"> */}
          <img component="img" alt="logo" src={logo} height="55px" />
          {/* </a> */}
        </Box>
        <Hidden mdUp>
          <Box display="flex" justifyContent="flex-end">
            {URL.client &&
              localStorageService.isAuthenticated() &&
              userData &&
              !userData.isGuest ? (
              <AnnouncementNavBar />
            ) : null}
            <IconButton
              aria-label="open drawer"
              onClick={() => toggleDrawer(openDrawer, setOpenDrawer)}
              size="large">
              <MenuIcon sx={{ color: "#fff" }} />
            </IconButton>
          </Box>
          <Drawer anchor="right" open={openDrawer} onClose={() => toggleDrawer(openDrawer, setOpenDrawer)}>
            <Box className={classes.drawerContent}>
              {!URL.room ? (
                <Typography className={classes.navBarTitle}>
                  {auctionType}
                </Typography>
              ) : null}
              <Box className={classes.navBarTextBox}>
                <AccountCircleIcon sx={(theme) => ({
                  color: theme.palette.primary.main,
                  fontSize: 30,
                })} />
                <Typography variant="body2"
                  sx={(theme) => ({
                    color: theme.palette.primary.main,
                    fontSize: 20,
                  })}
                >
                  Bienvenido
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={(theme) => ({
                    color: theme.palette.primary.main,
                    fontSize: 20,
                  })}
                >
                  {userData?.name
                    ? userData?.isGuest
                      ? `${userData.name} (Invitado)`
                      : `${userData.name} ${userData.lastName}`
                    : ``}
                </Typography>
                <PingIndicator ping={ping} />
              </Box>
              {URL.client &&
                localStorageService.isAuthenticated() &&
                userData &&
                !userData.isGuest ? (
                <>
                  <hr className={classes.divider} />
                  <Awards />
                </>
              ) : null}
              {localStorageService.isLogged() && userData ? (
                <>
                  <hr className={classes.divider} />
                  {URL.client && auction.phase === AUCTION_STATUS.INICIO ? (
                    <Button fullWidth onClick={() => restartTutorial(setUserEl, setShowTutorial)}>
                      <Typography
                        variant="subtitle2"
                        className={classes.navBarTextHighligt}
                      >
                        Reiniciar Tutorial
                      </Typography>
                    </Button>
                  ) : null}
                  <Button fullWidth onClick={() => logout(setUserEl, history)}>
                    <Typography
                      variant="subtitle2"
                      sx={(theme) => ({
                        color: theme.palette.primary.main,
                        fontSize: 20,
                      })}
                    >
                      Cerrar Sesión
                    </Typography>
                  </Button>
                </>
              ) : null}
              {URL.client &&
                userData &&
                !userData.isGuest &&
                !(userData.roleId < 5) ? (<>
                  <hr className={classes.divider} />
                  <Box className={classes.navBarTextBox}>
                    {specialMarkLabel ? (
                      <Typography variant="subtitle2" className={classes.guaranteeValue} sx={{ fontSize: 20 }}>
                        {specialMarkLabel}
                      </Typography>
                    ) : (
                      <>
                        <Typography
                          variant="subtitle2"
                          sx={(theme) => ({
                            color: theme.palette.primary.main,
                            fontSize: 20,
                          })}
                        >
                          {`Garantía Disponible: `}
                        </Typography>
                        <Typography variant="subtitle2" className={getColorClass(URL, userData, classes)} sx={{ fontSize: 20 }}>
                          {!userData.loadingUserGuarantee &&
                            typeof userData.userGuarantee === 'number' ? (
                            formatMoney(userData.userGuarantee)
                          ) : (
                            <CircularProgress />
                          )}
                        </Typography>
                      </>
                    )}
                    <UpdateUserGuarantee
                      visible={!userData.loadingUserGuarantee}
                      onClick={() => syncUserGuarantee(setUserData, socketUser, auction, userData)}
                    />
                  </Box>
                </>
              ) : null}
            </Box>
          </Drawer>
        </Hidden>
        <Hidden mdDown>
          {!URL.room ? (
            <Typography className={classes.navBarTitle}>
              {auctionType}
            </Typography>
          ) : null}
          {URL.dashboard ? (
            <>
              <Box
                className={
                  !settingsEl
                    ? classes.navBarTextBox
                    : classes.navBarTextBoxSelected
                }
                onClick={(e) => handleSettingsClick(e, setSettingsEl)}
              >
                <SettingsIcon
                  className={classes.navBarIcon}
                  color={settingsEl ? 'white' : 'secondary'}
                />
                <Typography
                  variant="body2"
                  className={classes.navBarText}
                  style={settingsEl ? { color: 'white' } : null}
                >
                  AJUSTES
                </Typography>
              </Box>
              <Popover
                open={Boolean(settingsEl)}
                anchorEl={settingsEl}
                onClose={() => handleClose(loadingUpdate, setUserEl, setSettingsEl)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                PaperProps={{ sx: { borderRadius: 3, boxShadow: '0 24px 64px rgba(15,38,71,.22)', overflow: 'hidden' } }}
              >
                <SettingsPanel
                  auction={auction}
                  loadingUpdate={loadingUpdate}
                  onClose={() => handleClose(loadingUpdate, setUserEl, setSettingsEl)}
                  onOpenAutomaticAuction={() => setOpenAutomaticAuctionDialog(true)}
                  onOpenLotsOrder={() => {
                    setOpenLotsOrderDialog(true)
                    handleClose(loadingUpdate, setUserEl, setSettingsEl)
                  }}
                  onOpenRestartAuction={() => setOpenDialog(true)}
                  onOpenUpdateAuction={() => setOpenDialogUpdateAcution(true)}
                />
              </Popover>
            </>
          ) : null}
          {/* Código legado del RobinHood anterior a este rediseño, fuera de operación. Bloque comentado junto con URL.robinhood más arriba.
          {URL.robinhood ? (
            <>
              <Box
                className={
                  !settingsEl
                    ? classes.navBarTextBox
                    : classes.navBarTextBoxSelected
                }
                onClick={(e) => handleSettingsClick(e, setSettingsEl)}
              >
                <SettingsIcon
                  className={classes.navBarIcon}
                  color={settingsEl ? 'white' : 'secondary'}
                />
                <Typography
                  variant="body2"
                  className={classes.navBarText}
                  style={settingsEl ? { color: 'white' } : null}
                >
                  AJUSTES
                </Typography>
              </Box>
              <Popover
                open={Boolean(settingsEl)}
                anchorEl={settingsEl}
                onClose={() => handleClose(loadingUpdate, setUserEl, setSettingsEl)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              >
                {auction.id ? (
                  <Box className={classes.settingsContainer} >
                    <Typography className={classes.settingsTitle}>
                      Descarga de reportes
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, marginTop: 1 }}>
                      <Button
                        className={classes.rhSettingsButton}
                        onClick={() => downloadReport(socketAdmin, auction)}
                      >
                        Reporte Robin Hood
                      </Button>
                      <Button
                        className={classes.rhSettingsButton}
                        onClick={() => reportApi.offerExcelReport(auction)}
                      >
                        Reporte de Ofertas
                      </Button>
                      {auction.auctionTypeId === 5 ?
                        <Button
                          className={classes.rhSettingsButton}
                          onClick={() => reportApi.lotOffersExcelReport({ auctionId: auction.id, areaId: auction.areaId, token: userData.token })}
                        >
                          Reporte de Lotes
                        </Button>
                        : null
                      }
                    </Box>
                  </Box>
                ) : null}
              </Popover>
            </>
          ) : null}
          */}
          <Box
            className={classes.navBarTextBox}
            style={{ cursor: userData ? 'pointer' : 'auto' }}
            onClick={(e) => handleUserClick(e, userData, setUserEl)}
          >
            {!URL.room ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <AccountCircleIcon
                  className={classes.navBarIcon}
                  color="secondary"
                />
                <Typography variant="body2" className={classes.navBarText}>
                  {userData?.name
                    ? userData?.isGuest
                      ? `Bienvenido ${userData.name} (Invitado)`
                      : `${userData.name} ${userData?.lastName}`
                    : `Bienvenido`}
                </Typography>
                {ping >= 0 ? (
                  <Tooltip title={'Ping: ' + ping} placement="bottom">
                    <Box>
                      <PingIndicator ping={ping} />
                    </Box>
                  </Tooltip>
                ) : null}
              </Box>
            ) : null}
          </Box>
          <Popover
            open={Boolean(userEl)}
            anchorEl={userEl}
            onClose={() => handleClose(loadingUpdate, setUserEl, setSettingsEl)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          >
            {URL.client && auction.phase === AUCTION_STATUS.INICIO ? (
              <Button onClick={() => restartTutorial(setUserEl, setShowTutorial)}>
                <Typography
                  variant="subtitle2"
                  className={classes.navBarTextHighligt}
                >
                  Tutorial
                </Typography>
              </Button>
            ) : null}
            <Button onClick={() => logout(setUserEl, history)}>
              <Typography
                variant="subtitle2"
                className={classes.navBarTextHighligt}
              >
                Cerrar Sesión
              </Typography>
            </Button>
          </Popover>
          {URL.client &&
            localStorageService.isAuthenticated() &&
            userData &&
            !userData.isGuest ? (
            <>
              <Divider
                orientation="vertical"
                style={{ height: '40%', width: 1, backgroundColor: '#004B8D' }}
              />
              <Awards />
              {auction.auctionTypeId === 5 ?
                <>
                  <Divider
                    orientation="vertical"
                    style={{ height: '40%', width: 1, backgroundColor: '#004B8D' }}
                  />
                  <LotOffers />
                </>
                : null
              }
            </>
          ) : null}
          {URL.client &&
            Boolean(userData) &&
            !userData.isGuest &&
            !(userData.roleId < 5) ? (
            <>
              <Divider
                orientation="vertical"
                style={{ height: '40%', width: 1, backgroundColor: '#004B8D' }}
              />
              <GuaranteeChip
                userData={userData}
                auction={auction}
                specialMarkLabel={specialMarkLabel}
                colorClass={getColorClass(URL, userData, classes)}
                onSync={() => syncUserGuarantee(setUserData, socketUser, auction, userData)}
              />
            </>
          ) : null}
        </Hidden>
      </Toolbar>
      <ConfirmationDialog
        open={openDialog}
        setOpen={setOpenDialog}
        title="Reiniciar Remate"
        action={() => restartAuction(socketAdmin, auction, userData)}
      >
        El remate se regresará a su estado inicial. Esta acción no se puede
        deshacer. Desea continuar?
      </ConfirmationDialog>
      <ConfirmationDialog
        open={openDialogUpdateAuction}
        setOpen={setOpenDialogUpdateAcution}
        title="Actualizar Remate"
        action={() => updateAuction(setLoadingUpdate, socketAdmin, auction, userData)}
      >
        El remate se actualizara. Desea continuar?
      </ConfirmationDialog>
      {auction.settings ? (
        <AutomaticAuctionDialog
          open={openAutomaticAuctionDialog}
          setOpen={setOpenAutomaticAuctionDialog}
        />
      ) : null}
      <LotsOrderDialog
        auction={auction}
        onClose={() => setOpenLotsOrderDialog(false)}
        open={openLotsOrderDialog}
      />
    </AppBar>
  );
}
export default Navbar
